module.exports = __webpack_public_path__ + "static/gap-5d28e070fac3ddd3e18ca35d5328ea23.png";